import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useTrackExpandNestedContent } from '@air/analytics';

import { useIsFlattenedView } from '~/hooks/search/useIsFlattenedView';
import { CentralizedBoardSelectors } from '~/store/centralizedBoard/selectors';

export const useToggleNestedItems = () => {
  const boardId = useSelector(CentralizedBoardSelectors.boardId);
  const { isFlattenedView, setIsFlattenedView } = useIsFlattenedView();
  const { trackExpandNestedContent } = useTrackExpandNestedContent();

  const toggleNestedItems = useCallback(() => {
    const nextIsFlattenedView = !isFlattenedView;

    setIsFlattenedView(nextIsFlattenedView);
    trackExpandNestedContent({
      action: nextIsFlattenedView ? 'expand' : 'collapse',
      ...(boardId && { board_id: boardId }),
    });
  }, [boardId, isFlattenedView, setIsFlattenedView, trackExpandNestedContent]);

  return { isFlattenedView, toggleNestedItems };
};
